import { useOutletContext } from "react-router-dom";

import PublisherSettings from "../../../components/publisher/PublisherSettings";

export default function LegacyDistributionSettings() {
	const { organization } = useOutletContext();

	return <PublisherSettings organizationId={organization.id} />;
}
